import styled from 'styled-components';

const ToggleBtnWrap = styled.div`

		#button-13{
				height: 24px;
    		width: 40px;
			.knobs{
				border-radius: 22px;
				height: 22px;
    		width: 40px;
				background-color: var(--toggleTrackDark);
				border: 1.5px solid var(--toggleTrackDark);
				transition: 0.25s;
				cursor: pointer;
				&:after,&:before{
					content: '' !important;
				}
				span{
					width: 20px;
					height:20px;
					left:1px;
					top:0;
					box-shadow: none;
					transition: 0.25s;
				}
			}
			.checkbox:disabled + .knobs{
				cursor: not-allowed;
				opacity: .6;
			}
		.checkbox:checked + .knobs:before{
			display:none;
		}

			.checkbox:checked + .knobs span {
					left: 18px;
			}
		}	
		}

`;

export {
	ToggleBtnWrap
};